import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import app from "./modules/app";
import user from "./modules/user";
import finance from "./modules/finance";
import links from "./modules/links";

export default new Vuex.Store({
  modules: {
    app,
    user,
    finance,
    links
  },
  state: {},
  mutations: {},
  actions: {}
});
